import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FlipRoadColumn, FlipRoadInput, FlipRoadOutput } from 'app/services/flip-road.service';

@Component({
  selector: 'app-feat-flip-road',
  templateUrl: './feat-flip-road.component.html',
  styleUrls: ['./feat-flip-road.component.css']
})
export class FeatFlipRoadComponent implements OnInit {
	
	transposeCheckAll: boolean;
	cols: FlipRoadColumn[];
	record;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: FlipRoadInput,
		private dialogRef: MatDialogRef<FeatFlipRoadComponent>
	) { }

	cancel() {
		const data: FlipRoadOutput = {
			cancel: true
		}
		this.dialogRef.close(data);
	}
	apply() {
		const data: FlipRoadOutput = {
			cols: this.cols.filter(c => c.isTransposed)
		}
		this.dialogRef.close(data);
	}

	toggleTransposeCheckAll() {
		this.cols.forEach(c => c.isTransposed = this.transposeCheckAll);
	}
	ngOnInit() {
		this.cols = this.data.cols;
		this.record = this.data.record;
	}

}
